import { useCookie } from '#imports'

import { DISABLE_TRACKERS_COOKIE_NAME } from '../constants'

/**
 * Used by E2E tests to forcefully enable/disable tracking
 */
export function useDisableTrackers() {
  // By default useCookie decodes via `destr`, which coerces "true" -> boolean true.
  // Keep the raw string value to avoid type/strict-equality surprises.
  const cookies = useCookie(DISABLE_TRACKERS_COOKIE_NAME, {
    decode: (value) => value,
  })

  return cookies?.value === 'true'
}
